<template>
  <div class="v2-about-us">
    <app-section theme="dark grid" class="who-are-we-section">
      <who-are-we />
    </app-section>
    <app-section theme="peach" wave-top wave-bottom class="about-us-section">
      <about-us-slider />
    </app-section>
    <app-section theme="nude grid" class="behind-the-scenes-section">
      <behind-the-scenes />
    </app-section>
    <app-section theme="blue">
      <kinds-of-porn-we-watch />
    </app-section>
    <app-section theme="dark" class="staff-picks-section">
      <staff-picks />
    </app-section>
    <app-section theme="nude">
      <better-than-others />
    </app-section>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import AppSection from "@/components/v2/section/index.vue";
import { amplitudePageViewTrack } from "@/utils/amplitude";
import BehindTheScenes from "@/components/v2/behind-the-scenes/index.vue";
import KindsOfPornWeWatch from "@/components/v2/kinds-of-porn-we-watch/index.vue";
import StaffPicks from "@/components/v2/staff-picks/index.vue";
import WhoAreWe from "@/components/v2/who-are-we/index.vue";
import AboutUsSlider from "@/components/v2/about-us-slider";
import BetterThanOthers from "@/components/v2/better-than-others/index.vue";

defineOptions({
  name: "about-us-v2",
});

onMounted(amplitudePageViewTrack);
</script>

<style lang="scss">
@import "./index.scss";
</style>
